module.exports = __webpack_public_path__ + "img/10-01.1b4a3182.jpg";